import React, { useState } from 'react';
export function UlfahAdvertorial() {
  // Get current date in Arabic format
  const getCurrentDateArabic = () => {
    const months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
    const date = new Date();
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };
  return <div dir="rtl" className="w-full min-h-screen bg-[#faf8f5]" data-id="element-2">
      {/* Header */}
      <header className="bg-[#2d2d2d] text-white py-4" data-id="element-3">
        <div className="max-w-4xl mx-auto px-4 flex items-center justify-between" data-id="element-4">
          <div className="text-[10px] text-gray-400" data-id="element-5">Advertorial</div>
          <div className="flex items-center gap-2" data-id="element-6">
            <span className="text-sm font-medium" data-id="element-7">🇲🇦 رائج فالمغرب</span>
          </div>
        </div>
      </header>

      {/* UPDATE Banner */}
      <div className="bg-gradient-to-l from-[#fff4d6] to-[#fef3c7] border-b-2 border-[#f59e0b]" data-id="element-8">
        <div className="max-w-4xl mx-auto px-4 py-5" data-id="element-9">
          <div className="flex items-start gap-3" data-id="element-10">
            <div className="flex-shrink-0" data-id="element-11">
              <div className="bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm" data-id="element-12">
                !
              </div>
            </div>
            <div className="flex-1" data-id="element-13">
              <p className="text-gray-900 text-base md:text-lg leading-relaxed" data-id="element-14">
                <span className="font-bold text-red-600" data-id="element-15">تحديث:</span> Ulfah
                كيتباع بسرعة فائقة! أمّن طلبك دابا باش تستافد من التخفيض ديال{' '}
                <span className="font-bold" data-id="element-16">35%</span> +{' '}
                <span className="font-bold" data-id="element-17">التوصيل المجاني</span> للمغرب
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-[#faf8f5] py-4" data-id="element-18">
        <div className="max-w-4xl mx-auto px-4" data-id="element-19">
          <nav className="text-sm text-gray-500" data-id="element-20">
            <span className="hover:text-gray-700 cursor-pointer" data-id="element-21">الرئيسية</span>
            <span className="mx-2" data-id="element-22">›</span>
            <span className="hover:text-gray-700 cursor-pointer" data-id="element-23">الزواج</span>
            <span className="mx-2" data-id="element-24">›</span>
            <span className="text-gray-700 font-medium" data-id="element-25">الصحة الزوجية</span>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <article className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-26">
        {/* Main Headline */}
        <h1 className="font-['Tajawal'] text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6" data-id="element-27">
          فريق مغربي يكتشف الحقيقة اللي ابن سينا كتبها قبل 1000 عام—وعلاش شركات
          الدواء خايفين منها؟
        </h1>

        {/* Subheadline */}
        <div className="bg-yellow-100 border-r-4 border-yellow-500 p-5 mb-8" data-id="element-28">
          <p className="text-gray-900 text-lg md:text-xl font-semibold leading-relaxed" data-id="element-29">
            إلا كنتي حاس بالرغبة ماتت وسط العلاقة، وخّا باقي كاين الحب… خاصك
            تقرا هادشي قبل ما تدير أي حاجة.
          </p>
        </div>

        {/* Hero GIF Section */}
        <div className="mb-8" data-id="element-30">
          <div className="rounded-lg overflow-hidden" data-id="element-31">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/29UnwigKdRpJfprVoxyHQb/ezgif.com-crop.png" alt="القانون في الطب - ابن سينا" className="w-full h-auto" data-id="element-32" />
          </div>
        </div>

        {/* Lead Box - Original Content */}
        <div className="bg-white border-2 border-gray-300 shadow-lg p-6 md:p-8 mb-8 rounded-lg" data-id="element-33">
          <p className="text-gray-800 text-base md:text-lg leading-relaxed mb-4" data-id="element-34">
            عدد حالات الطلاق فالمغرب تزاد بشكل خطير، وخا الأسباب الظاهرة كتكون
            مادية أو نفسية…
          </p>
          <p className="text-gray-800 text-base md:text-lg leading-relaxed mb-4" data-id="element-35">
            الحقيقة اللي ما كيبغيوكش تعرفها:{' '}
            <mark className="bg-yellow-200 px-1" data-id="element-36">
              الرغبة كتكون أول حاجة كتختفي… وكتجر معاها العلاقة كاملة.
            </mark>
          </p>
          <p className="text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-37">
            والمفاجأة؟{' '}
            <mark className="bg-yellow-200 px-1" data-id="element-38">
              ابن سينا شرح هاد الظاهرة قبل 1000 عام…
            </mark>{' '}
            وخلّى وصفة رجعات اليوم للحياة، على يد علماء مغاربة.
          </p>
        </div>

        <div className="h-px bg-gray-300 mb-8" data-id="element-39"></div>

        {/* Ibn Sina Story - Regular Text */}
        <div className="prose prose-lg max-w-none mb-8" data-id="element-40">
          {/* Ibn Sina Portrait - Moved to top and smaller on desktop */}
          <div className="mb-6" data-id="element-41">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ncb26yGp2FRUczoZJiyzRR/ChatGPT_Image_Nov_24%2C_2025%2C_11_20_11_AM.png" alt="ابن سينا" className="w-full md:w-2/3 lg:w-1/2 mx-auto rounded-lg shadow-lg" data-id="element-42" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-43">
            <span className="font-bold" data-id="element-44">
              ابن سينا - الطبيب اللي سماوه "الشيخ الرئيس"...
            </span>
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-45">
            عاش قبل 1000 عام، ولكن تأثيرو باقي واقف حتى اليوم.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-46">
            بدّل وجه الطب فالعالم كامل وخلّا إرث طبي عاش أكثر من 600 عام.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-47">
            فمسيرتو الطبية، عالج آلاف المرضى اللي جاوه بكل أنواع المشاكل الصحية:
          </p>

          <ul className="list-none space-y-3 mb-8 mr-6" data-id="element-48">
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-49">
              • مشاكل الهضم والمعدة
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-50">
              • أمراض القلب والدورة الدموية
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-51">
              • الاضطرابات النفسية والعصبية
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-52">
              • ومشاكل الطاقة الجنسية والعلاقة الزوجية
            </li>
          </ul>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-53">
            شاف كلشي.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-54">
            من شبان فقدو الرغبة فأول سنين الزواج...
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-55">
            حتى لحالات اللي وصلت درجة أن الرغبة ماتت تماماً رغم أن الحب باقي
            قوي.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-56">
            ولكن واحد النهار، فاش كان كيكتب "القانون في الطب"...
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-57">
            كتب فصل كامل على واحد الظاهرة اللي لاحظها فبزاف ديال مرضاه.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-58">
            ابن سينا سماها:
          </p>

          <div className="bg-[#f0f7f4] border-r-4 border-[#2d5f3f] p-6 rounded-lg mb-6" data-id="element-59">
            <p className="text-[#2d5f3f] text-xl md:text-2xl font-bold" data-id="element-60">
              "ضعف قوة البدن"
            </p>
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-61">
            وماشي غير وصف المشكل...
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-62">
            كتب السبب الحقيقي ديالها... والعلاج الكامل.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-63">
            خطوة بخطوة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-64">
            مكوّن بمكوّن.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-65">
            بالمقادير الدقيقة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-66">
            والحاجة المثيرة؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-67">
            العلم الحديث، بعد 1000 عام، أثبت أن كل كلمة كتبها ابن سينا... كانت
            صحيحة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-68">
            كل مكوّن فالوصفة ديالو... الدراسات الطبية اليوم كتقول عليه نفس
            الحاجة اللي قال هو.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8 font-bold" data-id="element-69">
            وهنا بداو الناس يفهمو علاش شركات الأدوية ما بغاوش هاد المعلومات توصل
            للعامة...
          </p>
        </div>

        {/* Biological Mechanism Section */}
        <div className="mb-8" data-id="element-70">
          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-71">
            علاش كتنقص الرغبة فعلاً؟ شنو كيوقع داخل الجسم
          </h3>

          {/* Stress Examples Image */}
          <div className="mb-8" data-id="element-72">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hkrGrhNGV4457aNNniPozm/Untitled_design.png" alt="أمثلة الضغط النفسي" className="w-full rounded-lg shadow-lg" data-id="element-73" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-74">
            الطب الحديث كيسمي هاد المشكل:
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-75">
            "الانهيار الهرموني الناتج عن الضغط النفسي المزمن."
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-76">
            يعني بكل بساطة:
          </p>

          <ul className="list-none space-y-3 mb-8 mr-6" data-id="element-77">
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-78">
              • الخدمة
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-79">
              • الصداع
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-80">
              • الفلوس
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-81">
              • قلة النوم
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-82">
              • المسؤوليات
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-83">
              • المشاكل اليومية
            </li>
          </ul>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-84">
            كلشي هادشي كيدخل الجسم فـ "وضع الحماية".
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-85">
            وفي وضع الحماية؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-86">
            الجسم كيسدّ باب الرغبة. كيحبس إنتاج الهرمونات اللي كتخليك بغيتي شريك
            حياتك.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-87">
            ماشي حيت الحب مات. ماشي حيت الزوج تبدّل. ماشي حيت العلاقة خسرات.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-88">
            ولكن حيت الجسم قال:
          </p>

          <div className="bg-[#fff9e6] border-r-4 border-[#f59e0b] p-6 rounded-lg mb-6" data-id="element-89">
            <p className="text-gray-900 text-xl font-bold text-center" data-id="element-90">
              "ماشي وقت الرغبة… دابا وقت النجاة."
            </p>
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-91">
            والمثير فالأمر؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-92">
            ابن سينا وصف نفس الظاهرة قبل 1000 عام.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-93">سماها:</p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-94">
            "ضعف قوة البدن."
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-95">
            وهاد المشكل ماشي خاص بالرجال فقط...
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-96">
            بل العكس.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-97">
            النساء كيعانيو من نفس الشي بالضبط - وأحياناً أكثر.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-98">
            حيت الضغط ديال البيت، الدراري، الخدمة، والمسؤوليات...
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-99">
            كيأثر على الهرمونات ديالها بنفس الطريقة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-100">
            ولهذا ابن سينا كان كيوصف نفس الوصفة للزوجين معاً.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8 font-semibold" data-id="element-101">
            حيت فاش واحد فيهم يرجع ليه التوازن... الآخر كيحس بالفرق تلقائياً.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-102">
            نفس الفكرة العلمية… غير بلغة ديال عصر آخر.
          </p>
        </div>

        {/* Ancient Formula Section */}
        <div className="mb-8" data-id="element-103">
          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-104">
            الوصفة اللي بقات مطمورة ألف عام
          </h3>

          {/* Ancient Manuscript Image */}
          <div className="mb-8" data-id="element-105">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/148oCA54XivrsAjS7Djsq3/1-13.jpg" alt="مخطوطة ابن سينا القديمة" className="w-full rounded-lg shadow-lg" data-id="element-106" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-107">
            الوصفة ديال ابن سينا ماكانتش "عشبة وحدة وخلاص." كانت نظام كامل خدام
            على جوج مراحل:
          </p>

          <div className="bg-white border border-gray-200 p-6 rounded-lg mb-6" data-id="element-108">
            <p className="text-gray-800 text-base leading-relaxed mb-4" data-id="element-109">
              <span className="font-bold text-[#2d5f3f]" data-id="element-110">المرحلة الأولى:</span>{' '}
              تهدئة الضغط من الجسم — تنظيم الأعصاب، تخفيض الكورتيزول، وإرجاع
              الجسم لوضع الراحة.
            </p>
            <p className="text-gray-800 text-base leading-relaxed" data-id="element-111">
              <span className="font-bold text-[#2d5f3f]" data-id="element-112">المرحلة الثانية:</span>{' '}
              تشغيل إنتاج الهرمونات من جديد… بشكل طبيعي، بلا إجبار، بلا
              كيماويات، بلا آثار جانبية.
            </p>
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-113">
            واللي مثير بزاف…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-114">
            عدد كبير من الأعشاب اللي كيعتمد عليها هاد البروتوكول هي نفسها اللي
            كانت جدّاتنا كيديروها فالشاي، فالحليب، فالعسل… باش يرجّعو الدار
            للدفء ديالها.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-115">
            غير الفرق؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-116">
            ابن سينا كان كيسجل المقادير… الجرعات… والتفسير العلمي ديال كل مكوّن.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-117">
            ولكن هاد الخلطة بقات مدفونة فالنصوص القديمة 1000 عام كاملة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-118">
            الطب الغربي؟ سماها "Folklore." "خرافات." وماعطاها حتى قيمة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-119">
            حتى جا فريق مغربي وقرّر يرجّعها للحياة.
          </p>
        </div>

        {/* Manufacturing Process Section */}
        <div className="mb-8" data-id="element-120">
          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-121">
            علاش خداهم عام كامل باش يصنعوها
          </h3>

          {/* Laboratory/Research Image */}
          <div className="mb-8" data-id="element-122">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jL7oE6QZozhnE6x7SuXV2J/shutterstock_1268263801-1.jpg" alt="مختبر البحث العلمي" className="w-full rounded-lg shadow-lg" data-id="element-123" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-124">
            الفريق المغربي فـ BioSeena ماخداوش الوصفة وخلطو شوية الأعشاب
            والسلام.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-125">
            لا.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-126">
            بغاو يرجعوها صح… بنفس الدقة اللي وصفها ابن سينا… وبنفس الجودة اللي
            أثبتوها الـ51 دراسة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-127">
            وهنا بدات المعركة الحقيقية:
          </p>

          <ul className="list-none space-y-3 mb-8 mr-6" data-id="element-128">
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-129">
              • كل عشبة خاصها تجي من البلاد اللي أثبتاتها الدراسات
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-130">
              • نفس الصنف
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-131">
              • نفس الجودة
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-132">
              • نفس المفعول
            </li>
          </ul>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-133">
            وهادشي خلاهم يسافرو بين 7 دول عبر 3 قارات:
          </p>

          <div className="bg-[#f0f7f4] p-6 rounded-lg mb-6" data-id="element-134">
            <ul className="list-none space-y-3" data-id="element-135">
              <li className="text-gray-800 text-base leading-relaxed" data-id="element-136">
                • الزعفران من إيران
              </li>
              <li className="text-gray-800 text-base leading-relaxed" data-id="element-137">
                • الأشواغاندا من الهند
              </li>
              <li className="text-gray-800 text-base leading-relaxed" data-id="element-138">
                • حبة البركة من مصر
              </li>
              <li className="text-gray-800 text-base leading-relaxed" data-id="element-139">
                • الماكا… الفينوجريك… المغنيزيوم…
              </li>
              <li className="text-gray-800 text-base leading-relaxed" data-id="element-140">
                • وكل واحد بطريقته وبمعاييره
              </li>
            </ul>
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-141">
            والمشكل؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-142">
            فاش كيوقع تأخير فالحصاد فشي دولة… الإنتاج كامل كيوقف.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-143">
            وممنوع تدير "بديل" أو "نوع رخيص"… حيت الوصفة كتخسر.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-144">
            أغلب الشركات؟ مايقدروش على هاد التعب. غالي بزاف، معقد بزاف،
            وماكيخليش ربح كبير.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-145">
            ولكن BioSeena كان عندهم قرار واضح:
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-146">
            يا نديروها صح… يا مانديروهاش.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-147">
            والنتيجة؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-148">
            Ulfah — أول إعادة تصنيع حديثة، دقيقة، وحلال للوصفة الأصلية ديال ابن
            سينا. مبنية على العلم القديم… ومدعومة بالبحث الحديث.
          </p>

          {/* Ulfah Product Image - Small and centered */}
          <div className="flex justify-center mb-8" data-id="element-149">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5ZCDz3bcvvnmVH1weuVBY2/100_Halal.png" alt="منتج Ulfah" className="w-48 md:w-56 h-auto" data-id="element-150" />
          </div>
        </div>

        {/* Social Commentary Section */}
        <div className="bg-white border-r-4 border-[#dc2626] p-6 md:p-8 mb-8 shadow-sm" data-id="element-151">
          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-152">
            الحقيقة اللي حتى واحد ماكيوصل ليها
          </h3>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-153">
            خلّيني نكون صريح معاك.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-154">
            الأنظمة اللي جبنا من الغرب ماكتخدمش مصلحتنا. كتخدم مصلحتهم هما:
            شركات الأدوية، شركات العلاج، اللي باغيينك تبقى "محتاج" طول حياتك.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-155">
            علاقة متوتّرة؟ مزيان ليهم. حيت غادي تشري:
          </p>

          <ul className="list-none space-y-3 mb-6 mr-6" data-id="element-156">
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-157">
              • مهدّئات
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-158">
              • فيتامينات عشوائية
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-159">
              • حبوب "مؤقتة"
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-160">
              • علاجات اللي ماكتصلحش للمشكل الأصلي
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-161">
              • ديبريصيون
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-162">
              • استشارات…
            </li>
            <li className="text-gray-800 text-base leading-relaxed" data-id="element-163">
              • ومصاريف كتجر مصاريف
            </li>
          </ul>

          {/* Burning Money Image */}
          <div className="mb-8" data-id="element-164">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pcKK2jejrw6SbYUz89gVUr/3ec9a2ec-2c90-40d0-8e66-b6a4d7c820d7.png" alt="مصاريف كتجر مصاريف" className="w-full rounded-lg shadow-lg" data-id="element-165" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-bold" data-id="element-166">
            هادا ماشي طب. هادا استعمار بطريقة جديدة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-167">
            فاش الرغبة كتختفي، العلاقة كتضعف. فاش العلاقة كتضعف، الجو فالدار
            كيخنق. فاش الجو كيخنق، الدراري كيعانيو.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-168">
            وهادشي كامل؟ السوق كيربح منّو.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-bold" data-id="element-169">
            فاش الدار كتطيح… البلاد كتطيح.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-170">
            وشوف دابا: أذكى شباب فالمغرب كيتمنّاو يخرجو. ماشي حيت كارهين البلاد…
            ولكن حيت الاستقرار ديال الدار ما بقاش.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-171">
            وهادشي كيبدا منين؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-172">
            من العلاقة بين الراجل ومراتو.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-173">
            العلاقة اللي خاصها تكون بركة، كتولي مصدر ضغط.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-174">
            الضحك كيمشي. الحنان كيمشي. الرغبة كتولي ذكرى. وكل واحد كينعس بوحدو
            فدماغو.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-175">
            وتعاود نفس الدائرة فكل جيل.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-176">
            هادشي ماشي خطأ ديال الناس… هادشي نتيجة ديال ضغط اللي مخلّي الهرمونات
            طايحة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-177">
            والحل ماشي "صبروا" ولا "تفاهموا" ولا "تأقلموا".
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-bold" data-id="element-178">
            الحل: رجّع للجسم التوازن اللي كيستاهل… والرغبة كتولي وحدها.
          </p>

          <p className="text-gray-800 text-base leading-relaxed" data-id="element-179">
            وهادشي اللي صلحو Ulfah.
          </p>
        </div>

        {/* Imagination Section */}
        <div className="mb-8" data-id="element-180">
          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-181">
            تخيل معايا...
          </h3>

          {/* Couple Image */}
          <div className="mb-8" data-id="element-182">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8SVCnHjWtRgC7bhjGmVfUU/df5368bb-888e-4e86-acc6-9ff3a89893fe.png" alt="زوجين سعيدين" className="w-full rounded-lg shadow-lg" data-id="element-183" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-184">
            ماتبقاش كتحشم من العلاقة مع شريك حياتك. ماتبقاش كتحس براسك "ميت" فاش
            جا الوقت. ماتبقاش كتشوف الحب فعينيه(ا) وماتقدرش تبادلو نفس الشعور.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-bold" data-id="element-185">
            هادشي كامل ممكن مع Ulfah.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-186">
            وأحسن حاجة؟
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6 font-semibold" data-id="element-187">
            كيبان التحسن فأقل من 30 يوم.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-188">
            غير تشرب 2 كبسولات كل نهار... وخلي جسمك يعاود ينتج الهرمونات بشكل
            طبيعي.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-189">
            دابا، عارف عندك جوج أسئلة مهمين...
          </p>
        </div>

        {/* Final Offer Section */}
        <div className="mb-8" data-id="element-190">
          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-191">
            فين تقدر تحصل على Ulfah؟
          </h3>

          {/* World Map Image */}
          <div className="mb-8" data-id="element-192">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aEPCsLkkL9prjgsH8BqYUi/5e824c99-0586-4028-b827-9861afd1fdd5.png" alt="خريطة العالم - مصادر المكونات" className="w-full rounded-lg shadow-lg" data-id="element-193" />
          </div>

          <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-194">
            ...وشحال الثمن؟
          </h3>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-195">
            السؤال الأول صعيب شوية…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-196">
            حيت كيخدو وقت وفلوس بزاف باش يصنعو هاد المنتوج…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-197">
            ماشي من التصنيع... ولكن من المكونات نفسها.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-198">
            BioSeena كيجيبو المكونات من 7 دول فـ 3 قارات - وكل مكوّن عندو مصدر
            واحد فقط فالعالم:
          </p>

          <ul className="list-none space-y-4 mb-8" data-id="element-199">
            <li className="flex items-start gap-3 text-gray-800 text-base leading-relaxed" data-id="element-200">
              <span className="text-xl flex-shrink-0" data-id="element-201">✓</span>
              <span data-id="element-202">
                <span className="font-semibold" data-id="element-203">الزعفران؟</span> 90% من الإنتاج
                العالمي جاي من إيران فقط.
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-800 text-base leading-relaxed" data-id="element-204">
              <span className="text-xl flex-shrink-0" data-id="element-205">✓</span>
              <span data-id="element-206">
                <span className="font-semibold" data-id="element-207">الأشواغاندا عالية الجودة؟</span>{' '}
                غير مناطق محددة فالهند.
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-800 text-base leading-relaxed" data-id="element-208">
              <span className="text-xl flex-shrink-0" data-id="element-209">✓</span>
              <span data-id="element-210">
                <span className="font-semibold" data-id="element-211">الماكا الأصلية؟</span> كتطلع غير
                فجبال الأنديز فالبيرو - فوق 4000 متر.
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-800 text-base leading-relaxed" data-id="element-212">
              <span className="text-xl flex-shrink-0" data-id="element-213">✓</span>
              <span data-id="element-214">
                <span className="font-semibold" data-id="element-215">تريبولوس الفعال؟</span> غير من
                البلقان... وكمية قليلة بزاف فالعالم.
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-800 text-base leading-relaxed" data-id="element-216">
              <span className="text-xl flex-shrink-0" data-id="element-217">✓</span>
              <span data-id="element-218">
                <span className="font-semibold" data-id="element-219">حبة البركة المصرية؟</span> أقوى
                نوع فالعالم - وإنتاجها محدود.
              </span>
            </li>
            <li className="flex items-start gap-3 text-gray-800 text-base leading-relaxed" data-id="element-220">
              <span className="text-xl flex-shrink-0" data-id="element-221">✓</span>
              <span data-id="element-222">
                <span className="font-semibold" data-id="element-223">المغنيزيوم المخلب؟</span>{' '}
                المصانع الحقيقية غير فألمانيا وأمريكا.
              </span>
            </li>
          </ul>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-224">
            وفاش كيوقع تأخير فالحصاد فشي دولة... الإنتاج كامل كيوقف.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-225">
            وهادشي كيخلينا معرضين باستمرار أننا نسالي من الستوك.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-226">
            الفريق ديالنا خدام 24/7 باش يأمن المكونات من هاد الـ7 دول ويصنع
            Ulfah كافي للناس الكل.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-227">
            ولكن نخاف نقول أننا مانقدروش نجاريو مع محدودية المواد الطبيعية عبر 3
            قارات.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-228">
            الطلب زاد بزاف... والمزارعين فإيران والهند والبيرو ومصر وبلغاريا...
            ماعندهومش كمية لا محدودة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-229">
            هادشي كامل كيخلي الستوك يسالي بسرعة كل مرة كنوصل شحنة جديدة من
            القارات التلاتة.
          </p>

          {/* Warning Section Title - Restored Original */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg p-6 md:p-8 mb-6 mt-8" data-id="element-230">
            <h3 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-red-600 text-center mb-4" data-id="element-231">
              تحذير:
            </h3>
            <p className="text-gray-900 text-lg md:text-xl font-bold text-center leading-relaxed" data-id="element-232">
              فاش غادي تقرا هاد الرسالة، ممكن يكون هاد العرض سالا من الستوك!
            </p>
          </div>

          {/* Empty Shelves Image */}
          <div className="mb-8" data-id="element-233">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qD1RPiAFjrmQyQC9uYvUXn/rupture_06beccfa-9477-4732-abd8-6a5f4590dc4d.webp" alt="رفوف فارغة" className="w-full rounded-lg shadow-lg" data-id="element-234" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-235">
            وفاش غادي يوقع هادشي…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-236">
            فاش غادي نسالي من الستوك…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-237">
            ممكن ياخد من شي أسابيع لشي شهور باش نرجعو نجيبو الستوك حيت هاد
            المنتوج كياخد وقت طويل باش يتصنع.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-238">
            إذن إلا كنتي جدي فأنك ترد الرغبة لزواجك…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-239">
            كننصحك ماتخرجش من هاد الصفحة…
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-240">
            حيت هادي ممكن تكون الفرصة الوحيدة ديالك باش تحصل على Ulfah وتعيش
            الراحة اللي كنتي كتدعي عليها.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-241">
            إذن، بلا مزيد من التأخير، خليني نوريك كيفاش تقدر تحصل على Ulfah
            اليوم.
          </p>

          <h4 className="font-['Tajawal'] text-xl md:text-2xl font-bold text-gray-900 mb-6 mt-8" data-id="element-242">
            Ulfah ماكينش متوفر فحتى مكان آخر غير فالموقع الرسمي ديالنا
          </h4>

          {/* Ulfah Product with X marks on competitors */}
          <div className="mb-8" data-id="element-243">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jm7VP1UPxDu8wZgQdzHeHV/725b1d00-0603-43f4-aec6-4f53e36bb944.png" alt="منتج Ulfah الأصلي - احذر من التقليد" className="w-full rounded-lg shadow-lg" data-id="element-244" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-245">
            ماتلقاوش فالمحلات. إلا شفتي شي حاجة شبيهة، داك غير تقليد رخيص.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-246">
            المكان الوحيد اللي تقدر تشري منو Ulfah الحقيقي والأصلي هو الموقع
            الرسمي ديالنا فين كيتباع بـ 570 درهم فقط.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-247">
            بالنظر للتكنولوجيا المتطورة اللي وراه وكيفاش المستخدمين كيشوفو
            النتائج بسرعة، هاد الثمن سرقة.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-248">
            باش تفهم أكثر، فاش استأجرنا خبراء الأعمال والتسويق باش يعاونونا
            نطلقو المنتوج فالسوق، قالوا لنا نطلبو 1200 درهم.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-249">
            وهادشي كان منطقي من الناحية التجارية.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-250">
            ولكن أنا ماشي تاجر. أنا باحث.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-251">
            والهدف الوحيد ديالي من هاد المنتوج أنني نعاون أكبر عدد ممكن من
            الناس.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-252">
            قررت نعطي تخفيض كبير ونخلي عندك Ulfah ديالك بـ 35% أقل من الثمن
            العادي
          </p>

          {/* CTA Button */}
          <div className="flex justify-center mb-12" data-id="element-253">
            <button className="bg-[#2d5f3f] hover:bg-[#234a32] text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg shadow-lg transition-colors duration-200" data-id="element-254">
              احجز تخفيضك 35% دابا — Ulfah
            </button>
          </div>

          {/* 90 Day Guarantee with Badge - ONLY ONE INSTANCE */}
          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-255">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hf2nn7pmy2h25zpbAkx7fE/ChatGPT_Image_Nov_18%2C_2025%2C_11_07_48_PM.png" alt="ضمان 90 يوم" className="w-16 h-16 md:w-20 md:h-20" data-id="element-256" />
            <p className="text-gray-800 text-base leading-relaxed font-semibold" data-id="element-257">
              عندك 90 يوم باش تجرب المنتوج، بلا أي مخاطر!
            </p>
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-258">
            تقدر تبدل الأمور. تقدر تحصل على الراحة اللي كنتي كتقلب عليها. تقدر
            ترجع لحياتك القديمة وتستمتع بالباقي من حياتك.
          </p>

          <h4 className="font-['Tajawal'] text-xl md:text-2xl font-bold text-gray-900 mb-6 mt-8" data-id="element-259">
            شنو خاصك تدير دابا
          </h4>

          {/* Choices Image */}
          <div className="mb-8" data-id="element-260">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uAqya85zAZt2GLF8svbysQ/c8d723da-3eef-4d2b-9919-704074131fb1.jpg" alt="الاختيارات" className="w-full rounded-lg shadow-lg" data-id="element-261" />
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-262">
            عندك جوج اختيارات فقط:
          </p>

          {/* Choice 1 - Red Box (Negative) */}
          <div className="bg-red-50 border-2 border-red-300 rounded-lg p-6 mb-6" data-id="element-263">
            <div className="flex items-start gap-3 mb-4" data-id="element-264">
              <div className="flex-shrink-0 text-3xl" data-id="element-265">❌</div>
              <p className="text-red-900 text-lg font-bold" data-id="element-266">
                الاختيار الأول: تبقى فنفس الوضعية اللي راك فيها.
              </p>
            </div>
            <p className="text-red-800 text-base leading-relaxed mr-12" data-id="element-267">
              تستنا وتشوف إلا الأمور غادي تتحسن "بوحدها". تبقى كتعاني من نفس
              المشكل شهر بعد شهر. تشوف العلاقة ديالك كتضعف أكثر فأكثر. وتندم
              بعدين أنك ماجربتيش الحل فاش كان متاح.
            </p>
          </div>

          {/* Choice 2 - Green Box (Positive) */}
          <div className="bg-green-50 border-2 border-green-400 rounded-lg p-6 mb-8" data-id="element-268">
            <div className="flex items-start gap-3 mb-4" data-id="element-269">
              <div className="flex-shrink-0 text-3xl" data-id="element-270">✅</div>
              <p className="text-green-900 text-lg font-bold" data-id="element-271">
                الاختيار الثاني: تجرب Ulfah دابا.
              </p>
            </div>
            <p className="text-green-800 text-base leading-relaxed mr-12" data-id="element-272">
              تعطي لجسمك الفرصة باش يرجع للتوازن الطبيعي ديالو. تشوف الرغبة
              كترجع فأقل من 30 يوم. تعيش العلاقة اللي كنتي كتحلم بيها من
              البداية. وتحس براحة البال أنك جربتي الحل الطبيعي والآمن.
            </p>
          </div>

          {/* New 90-Day Guarantee Section with Large Badge */}
          <div className="bg-gradient-to-br from-amber-50 to-yellow-50 border-2 border-amber-300 rounded-xl p-8 md:p-10 mb-8 shadow-lg" data-id="element-273">
            <h4 className="font-['Tajawal'] text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-274">
              وتعاود تفكر: ماكاينة حتى مخاطرة
            </h4>

            {/* Large 90-Day Badge */}
            <div className="flex justify-center mb-6" data-id="element-275">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hf2nn7pmy2h25zpbAkx7fE/ChatGPT_Image_Nov_18%2C_2025%2C_11_07_48_PM.png" alt="ضمان 90 يوم" className="w-32 h-32 md:w-40 md:h-40" data-id="element-276" />
            </div>

            <p className="text-gray-800 text-lg md:text-xl leading-relaxed mb-4 text-center font-semibold" data-id="element-277">
              عندك 90 يوم كامل باش تجرب Ulfah.
            </p>

            <div className="space-y-4 text-center" data-id="element-278">
              <p className="text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-279">
                إلا ماشفتيش أي تحسن فالرغبة... إلا ماحسيتيش بفرق فالطاقة... إلا
                الأمور ما تبدلوش للأحسن...
              </p>

              <p className="text-gray-900 text-lg md:text-xl font-bold" data-id="element-280">
                نرجعو ليك فلوسك كاملة. بلا أسئلة. بلا صداع.
              </p>

              <p className="text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-281">
                يعني إلا Ulfah ماخدمش معاك - ماخسرتي والو.
              </p>

              <p className="text-green-700 text-lg md:text-xl font-bold mt-6" data-id="element-282">
                ولكن إلا خدم معاك (وهادشي اللي وقع مع 94% من الناس اللي
                جربوه)...
              </p>

              <p className="text-gray-900 text-xl md:text-2xl font-bold" data-id="element-283">
                غادي تعيش تحول كامل فحياتك الزوجية.
              </p>
            </div>
          </div>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-284">
            الاختيار عندك.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-285">
            ولكن تعاود تفكر:
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-286">
            هاد الفرصة ممكن ماتجيش مرة أخرى.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-6" data-id="element-287">
            المخزون محدود فعلاً بسبب ندرة المكونات من 7 دول.
          </p>

          <p className="text-gray-800 text-base leading-relaxed mb-8" data-id="element-288">
            والتخفيض 35% متوفر فهاد الصفحة بوحدها لـ48 ساعة فقط.
          </p>

          {/* Final CTA Button */}
          <div className="flex justify-center mb-12" data-id="element-289">
            <button className="bg-[#2d5f3f] hover:bg-[#234a32] text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg shadow-lg transition-colors duration-200" data-id="element-290">
              احجز تخفيضك 35% دابا
            </button>
          </div>

          {/* Last CTA Button */}
          <div className="flex justify-center mb-12" data-id="element-291"></div>
        </div>

        {/* Bottom Urgency Section - Yellow Box with Trust Badges */}
        <div className="bg-gradient-to-l from-[#fff4d6] to-[#fef3c7] border-2 border-[#f59e0b] rounded-lg p-6 md:p-8 mb-8" data-id="element-292">
          {/* Dynamic Date Update */}
          <div className="mb-6" data-id="element-293">
            <p className="text-gray-900 text-base md:text-lg leading-relaxed" data-id="element-294">
              <span className="font-bold text-red-600" data-id="element-295">
                حسب {getCurrentDateArabic()}
              </span>{' '}
              - الطلب على Ulfah زاد بشكل كبير والمخزون كيطير من على الرفوف. احجز
              ديالك قبل ما يفوت الأوان.
            </p>
          </div>

          {/* Main CTA Text */}
          <h4 className="font-['Tajawal'] text-xl md:text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-296">
            احجز الطلب ديالك دابا باش تحصل على التخفيض قبل ما يسالي
          </h4>

          <p className="text-gray-900 text-base md:text-lg font-semibold mb-6 text-center" data-id="element-297">
            هاد التخفيض ماكين فحتى شي بلاصة
          </p>

          {/* Trust Badges Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-298">
            <div className="flex flex-col items-center text-center" data-id="element-299">
              <div className="text-3xl mb-2" data-id="element-300">✅</div>
              <p className="text-gray-900 text-sm md:text-base font-medium" data-id="element-301">
                ضمان إرجاع الفلوس لـ90 يوم
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-302">
              <div className="text-3xl mb-2" data-id="element-303">✅</div>
              <p className="text-gray-900 text-sm md:text-base font-medium" data-id="element-304">
                الدفع آمن ومضمون
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-305">
              <div className="text-3xl mb-2" data-id="element-306">✅</div>
              <p className="text-gray-900 text-sm md:text-base font-medium" data-id="element-307">
                إرجاع بلا صداع
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-308">
              <div className="text-3xl mb-2" data-id="element-309">✅</div>
              <p className="text-gray-900 text-sm md:text-base font-medium" data-id="element-310">
                توصيل سريع
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex justify-center mb-6" data-id="element-311">
            
          </div>

          {/* Final Tagline */}
          <p className="text-gray-900 text-base md:text-lg font-semibold text-center mb-4" data-id="element-312">
            أخيراً رد الرغبة والحيوية لعلاقتك الزوجية
          </p>

          {/* Second CTA Button */}
          <div className="flex justify-center" data-id="element-313">
            <button className="bg-[#2d5f3f] hover:bg-[#234a32] text-white font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg shadow-lg transition-colors duration-200 w-full md:w-auto" data-id="element-314">
              احجز تخفيضك 35% دابا!
            </button>
          </div>
        </div>

        {/* Footer Disclaimer */}
        <div className="text-center text-gray-500 text-sm border-t border-gray-300 pt-6 pb-6" data-id="element-315">
          <p data-id="element-316">إعلان</p>
        </div>
      </article>
    </div>;
}